import { Button, PageHeader } from '@lmc/ui-kit'
import { ProTag } from 'components/ProTag'
import { useRouter } from 'hooks/useRouter'
import { FC } from 'react'
import { isBrowser, isTablet } from 'react-device-detect'
import { useTranslation } from 'react-i18next'
import { Icon } from '@lmc/ui-kit'
import styled from 'styled-components'

type Props = {
  handleToggleModal: () => void
  handleView: () => void
  residentName: string | undefined
  testId?: string
}

const isDesktop = isBrowser || isTablet

export const ResidentNeedsHeaderSection: FC<Props> = ({
  handleToggleModal,
  residentName,
  testId
}) => {
  const { t } = useTranslation()

  const router = useRouter()

  const pageHeaderTitle = residentName
    ? `${residentName}'s ${t('skillsAndNeeds.needs')}`
    : t('skillsAndNeeds.needs')

  return (
    <Wrapper
      data-testid={
        testId ? `${testId}-needs-header-section` : 'needs-header-section'
      }
    >
      <PageHeader
        sticky
        onBack={!isDesktop ? () => router.navigate(-1) : undefined}
        title={
          <TitleContainer>
            {pageHeaderTitle} <ProTag />
          </TitleContainer>
        }
        data-testid={
          testId ? `${testId}-needs-page-header` : 'needs-page-header'
        }
      >
        <Button
          onClick={handleToggleModal}
          icon={<Icon name="PlusOutlined" />}
          variant="primary"
          data-testid={
            testId ? `${testId}-needs-add-button` : 'needs-add-button'
          }
        >
          {t(`skillsAndNeeds.assignNewNeedButton`)}
        </Button>
      </PageHeader>
    </Wrapper>
  )
}

export default ResidentNeedsHeaderSection

// Styled Components
const Wrapper = styled.div`
  margin-bottom: 24px;
`

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`
